import React from 'react'

import { Dialog } from 'components'

const ReplicateMarkupsDialog = ({ frameType, ...props }) => (
  <Dialog
    {...props}
    id='replicate-markups-dialog'
    title='Warning'
    width={400}
  >
    <p>
      You are about to apply this pricing to all
      your {frameType.id === 1 ? 'Art Prints' : 'Framed Prints'}.
    </p>
    <p>
      Please note; for Landscape/Portrait formats, only these artworks will be
      updated. Similarly, for Square formats, only Square artworks will be
      updated.
    </p>
    <p>
      Artworks that are already published will not be affected. Please
      unpublish your artworks first to edit pricing.
    </p>
  </Dialog>
)

export default ReplicateMarkupsDialog



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/ViewContent/ReplicateMarkupsDialog.js